import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DelayedInputDirective } from './delayed-input.directive';
import { RunScriptsDirective } from './runscript.directive';
import { LoadHtmlFromUrlDirective } from './loadhtml.directive';


@NgModule({
  declarations: [
    DelayedInputDirective,
    RunScriptsDirective,
    LoadHtmlFromUrlDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DelayedInputDirective,
    RunScriptsDirective,
    LoadHtmlFromUrlDirective
  ]
})
export class DirectivesModule { }
